import { matchPath } from "react-router";
import type { AdminArea } from "./offering";

// Which entry of the sidebar is marked for an address. The rule is the longest match of the path, so `/customers/privacy` marks Privacy and
// not Customers as well. One exception: a plan page (`/trips/:tripId/itinerary`) belongs to no entry of its own (Trips is not listed), and a
// staff member reaches it from a conversation, so it marks Concierge. A role without Concierge sees no entry marked.

const ITINERARY_PAGES = "/trips/:tripId/itinerary/*";
const ITINERARY_PARENT = "concierge";

export function activeNavigationKey(
  navigation: readonly AdminArea[],
  pathname: string,
): string | null {
  if (matchPath({ path: ITINERARY_PAGES }, pathname) !== null) {
    return navigation.some((item) => item.key === ITINERARY_PARENT) ? ITINERARY_PARENT : null;
  }
  let best: AdminArea | null = null;
  for (const item of navigation) {
    const matches = pathname === item.path || pathname.startsWith(`${item.path}/`);
    if (matches && (best === null || item.path.length > best.path.length)) best = item;
  }
  return best?.key ?? null;
}
